import { Pipe, PipeTransform } from "@angular/core";
import { ScoreCutoffs } from "src/app/core/models/score-cutoffs.model";
import { getZone } from "src/app/core/utils/zone";

@Pipe({
  name: 'zone',
  standalone: true,
})
export class ZonePipe implements PipeTransform {
  transform = getZone;
}
